import { AxiosResponse } from 'axios';
import { APIResponse } from '../Helper/type';
import { handleApiResponse } from '../Helper/apiResponseHandler';
import IResetPassword from './ResetPassword.interface';
import apiCallWrapper from '../../apiwrapper/apiCallWrapper';

// Declaring the web server path to call api
const backEndServerUrl = String(process.env.REACT_APP_BACK_END_SERVER_URL ?? '');
/* this class is used to call reset password api, when user click on reset password button it will
verify the code first and then resets password */
export default class ResetPassword {
  public apiResponse: APIResponse | undefined;
  constructor(public userInfo: IResetPassword) {}
  // Declaring the sub-path
  public subPath: string = '/reset/confirmpassword';

  // Post request to reset user password with verfication code.
  public async resetPassword(): Promise<APIResponse> {
    try {
      // calling wrapper function to wrap the header.
      const axiosWithRoles = apiCallWrapper(this.subPath, 'POST');
      const url: string = this.createUrl(this.subPath);
      const requestBody: any = this.userInfo;
      const response: AxiosResponse<any, any> = await axiosWithRoles.post(url, requestBody);
      const errorMessage = '';
      const successMessage = '';
      this.apiResponse = handleApiResponse(response.status, errorMessage, successMessage);
    } catch (error: any) {
      switch (error?.response?.status) {
        case 400:
          this.apiResponse = {
            statusCode: 400,
            body: 'Invalid verification code.'
          };
          break;
        case 401:
          this.apiResponse = {
            statusCode: 401,
            body: 'Verification code has expired.'
          };
          break;
        default:
          this.apiResponse = { statusCode: 500, body: JSON.stringify(error) };
      }
    }
    return this.apiResponse;
  }

  // Binding the Webserver path and sub-path
  private createUrl(params?: string): string {
    return `${backEndServerUrl}${params}`;
  }
}
